import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'app/core.module';
import { ModalModule } from 'ng2-bootstrap';
import { UserChangePwdModalComponent } from './user-change-pwd-modal/user-change-pwd-modal.component';

@NgModule({
  imports: [
    CoreModule,
    ModalModule.forRoot(),
    ReactiveFormsModule
  ],
  exports: [
    UserChangePwdModalComponent
  ],
  declarations: [UserChangePwdModalComponent]
})
export class CommonModalModule { }



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/shared/common-modal/common-modal.module.ts